import { useMe } from '@/context/MeProvider'

function emailInitial(email: string): string {
  const letter = email.trim().charAt(0)
  return letter ? letter.toUpperCase() : '?'
}

export function MeStatus() {
  const { me, loading, error, refresh } = useMe()

  if (error) {
    return (
      <button
        type="button"
        onClick={() => {
          void refresh()
        }}
        className="font-body text-label-sm text-fg-muted hover:text-fg hidden rounded-sm sm:block"
      >
        Couldn&apos;t load your profile · Retry
      </button>
    )
  }
  if (loading || me === null) {
    return (
      <p className="font-body text-label-sm text-fg-muted hidden sm:block">
        Loading…
      </p>
    )
  }

  return (
    <div className="font-body text-label-sm text-fg-muted flex items-center gap-2">
      {!me.emailVerified && (
        <span className="text-secondary hidden shrink-0 sm:inline">
          Verify email
        </span>
      )}
      {me.status !== 'active' && (
        <span className="text-error hidden shrink-0 sm:inline">Suspended</span>
      )}
      <span className="group relative shrink-0">
        <span
          tabIndex={0}
          aria-label={me.email}
          className="border-glass-border bg-primary-container/15 text-primary font-display flex size-7 cursor-default items-center justify-center rounded-full border text-xs font-semibold"
        >
          {emailInitial(me.email)}
        </span>
        <span
          role="tooltip"
          className="border-glass-border bg-surface-container-high text-fg pointer-events-none absolute top-full right-0 z-50 mt-2 hidden w-max rounded-md border px-2 py-1 whitespace-nowrap shadow-lg group-hover:block group-focus-within:block"
        >
          {me.email}
        </span>
      </span>
      <span className="bg-primary-container/15 text-primary border-glass-border shrink-0 rounded-full border px-2 py-0.5 font-semibold tabular-nums">
        {me.points} pts
      </span>
    </div>
  )
}
